// import React, { useState } from "react";

// import { Button, Form, Grid, Input, message, Spin, theme } from "antd";

// import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { logIn } from "../Service/login";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;

// export default function Login() {
//   const navigate = useNavigate();
//   const { token } = useToken();
//   const screens = useBreakpoint();
//   const [isLoading, setIsLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const onFinish = (values) => {
//     setIsLoading(true);
//     logIn(values)
//       .then((res) => {
//         console.log("res.data", res);
//         if (res.status === 200) {
//           navigate(`/login-otp/${values.email}`, { replace: true });
//         }
//       })
//       .catch((err) => {
//         console.log("err", err);
//         const msg = err.response.data?.message
//           ? err.response.data.message
//           : err.message;

//         messageApi.open({
//           type: "error",
//           content: msg || "Server error",
//         });
//       })
//       .finally(() => {
//         setIsLoading(false);
//       });
//   };

//   const styles = {
//     container: {
//       backgroundColor: "rgba(255, 255, 255, 0.2)", // Transparent white with some opacity.
//       borderRadius: "10px",
//       backdropFilter: "blur(28px)", // Optional for visual effect.
//       padding: screens.md
//         ? `${token.paddingXL}px`
//         : `${token.sizeXXL}px ${token.padding}px`,
//       width: "auto", // Remove the fixed width for better flexibility.
//       alignSelf: "flex-end", // Align the `div` itself to the right if needed.
//       width: "350px",
//     },

//     footer: {
//       marginTop: token.marginLG,
//       textAlign: "center",
//       width: "100%",
//     },
//     forgotPassword: {
//       paddingTop: "10px",
//       float: "right",
//       color: "#d3d5dfff",
//     },
//     header: {
//       marginBottom: token.marginXL,
//     },

//     section: {
//       backgroundColor: token.colorBgContainer,
//       display: "flex",
//       flexDirection: "column", // For vertical stacking; change to "row" if you want a horizontal layout.
//       justifyContent: "center", // Vertically centers items.
//       alignItems: "flex-end", // Aligns items horizontally to the right.
//       minHeight: "100vh", // Ensures full viewport height.
//       backgroundPosition: "center",
//       backgroundSize: "cover",
//       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
//       width: "100%", // Ensures the section spans the full width.
//     },

//     text: {
//       color: "black",
//     },
//     title: {
//       fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
//     },
//   };

//   const useDetails = Cookies.get("user_details");

//   return useDetails ? (
//     <Navigate to="/configuration" replace={true} />
//   ) : (
//     <>
//       <section
//         style={{
//           ...styles.section,
//           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
//         }}
//       >
//         {contextHolder}
//         <div
//           style={{
//             ...styles.container,
//           }}
//         >
//           <div
//             style={{
//               textAlign: "center",
//               paddingBottom: "1rem",
//               display: "flex",
//               width: "100%",
//               justifyContent: "center",
//               color: "white",
//             }}
//           >
//             <img
//               src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//               alt="Logo"
//               style={{
//                 width: "2rem",
//                 height: "auto",
//                 borderRadius: "50%",
//                 marginRight: "10px",
//               }}
//             />
//             <h2>Step to Innovation</h2>
//           </div>
//           <Form
//             name="normal_login"
//             initialValues={{
//               remember: true,
//             }}
//             onFinish={onFinish}
//             layout="vertical"
//             requiredMark="optional"
//           >
//             <Form.Item
//               name="email"
//               label={
//                 <span style={{ color: "#d3d5dfff", fontWeight: "600" }}>
//                   EMAIL
//                 </span>
//               }
//               rules={[
//                 {
//                   required: true,
//                   message: "Please input your email!",
//                 },
//               ]}
//             >
//               <Input
//                 style={{ padding: "8px 12px" }}
//                 prefix={<UserOutlined />}
//                 placeholder="Email"
//               />
//             </Form.Item>
//             <Form.Item
//               name="password"
//               label={
//                 <div style={{ color: "#d3d5dfff", fontWeight: "600" }}>
//                   PASSWORD
//                 </div>
//               }
//               rules={[
//                 {
//                   required: true,
//                   message: "Please input your Password!",
//                 },
//               ]}
//             >
//               <Input.Password
//                 prefix={<LockOutlined />}
//                 type="password"
//                 placeholder="Password"
//                 style={{ padding: "8px 12px" }}
//               />
//             </Form.Item>
//             <Form.Item style={{ marginBottom: "0px" }}>
//               <Button
//                 block="true"
//                 type="primary"
//                 htmlType="submit"
//                 style={{
//                   padding: "20px 12px",
//                   backgroundColor: isLoading ? "#1677ff" : undefined,
//                   borderColor: isLoading ? "#1677ff" : undefined,
//                   cursor: isLoading ? "not-allowed" : undefined,
//                 }}
//                 disabled={isLoading}
//                 icon={
//                   <Spin
//                     spinning={isLoading}
//                     indicator={<SyncOutlined spin />}
//                     // size="small"
//                     style={{ color: "white" }}
//                   />
//                 }
//               >
//                 {!isLoading ? "Log in" : ""}
//               </Button>
//             </Form.Item>
//             <Link to="/forget-password" style={styles.forgotPassword}>
//               Forgot password?
//             </Link>
//           </Form>
//         </div>
//       </section>
//     </>
//   );
// }
import React, { useState } from "react";
import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { logIn } from "../Service/login";

const { useToken } = theme;
const { useBreakpoint } = Grid;

export default function Login() {
  const navigate = useNavigate();
  const { token } = useToken();
  const screens = useBreakpoint();

  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = (values) => {
    setIsLoading(true);
    logIn(values)
      .then((res) => {
        if (res.status === 200) {
          navigate(`/login-otp/${values.email}`, { replace: true });
        }
      })
      .catch((err) => {
        const msg =
          err.response?.data?.message || err.message || "Server error";
        messageApi.open({
          type: "error",
          content: msg,
        });
      })
      .finally(() => setIsLoading(false));
  };

  const userDetails = Cookies.get("user_details");

  const styles = {
    section: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center", // vertical centering
      alignItems: "flex-end", // 👈 push card to the right
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",

      // 👇 SAME logic as old code
      padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
    },

    container: {
      // background: "#ffffff",
      background: "rgba(255, 255, 255)",
      borderRadius: "12px",
      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
      padding: "40px",
      width: "420px", // fixed width is important
    },

    header: {
      textAlign: "center",
      marginBottom: "32px",
    },

    title: {
      fontSize: "28px",
      fontWeight: 700,
      color: "#1a202c",
      marginBottom: "8px",
    },

    subtitle: {
      fontSize: "14px",
      color: "#718096",
    },

    label: {
      fontSize: "14px",
      fontWeight: 600,
      color: "#2d3748",
    },

    input: {
      padding: "12px 16px",
      borderRadius: "8px",
      fontSize: "16px",
    },

    button: {
      height: "48px",
      fontSize: "16px",
      fontWeight: 600,
      borderRadius: "8px",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      border: "none",
    },

    forgotPassword: {
      marginTop: "16px",
      textAlign: "center",
      display: "block",
      color: "#667eea",
      fontSize: "14px",
      fontWeight: 500,
    },
  };

  return userDetails ? (
    <Navigate to="/configuration" replace />
  ) : (
    <>
      {contextHolder}
      <section
        style={{
          ...styles.section,
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
        }}
      >
        <div style={styles.container}>
          {/* Header */}
          <div style={styles.header}>
            {/* <h2 style={styles.title}>Sign In</h2> */}
            <div
              style={{
                textAlign: "center",
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
                alt="Logo"
                style={{
                  width: "5rem",
                  height: "auto",
                  borderRadius: "50%",
                  marginRight: "10px",
                }}
              />
              <h2>Step to Innovation</h2>
            </div>
            <p style={styles.subtitle}>
              Enter your credentials to login your account
            </p>
          </div>

          {/* Login Form */}
          <Form
            name="login_form"
            layout="vertical"
            requiredMark={false}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              label={<span style={styles.label}>Email Address</span>}
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Enter your email"
                style={styles.input}
              />
            </Form.Item>

            <Form.Item
              name="password"
              label={<span style={styles.label}>Password</span>}
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Enter your password"
                style={styles.input}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                block
                type="primary"
                htmlType="submit"
                style={styles.button}
                disabled={isLoading}
                icon={
                  isLoading ? (
                    <Spin
                      indicator={<SyncOutlined spin />}
                      style={{ color: "white" }}
                    />
                  ) : null
                }
              >
                {!isLoading && "Sign In"}
              </Button>
            </Form.Item>

            <Link to="/forget-password" style={styles.forgotPassword}>
              Forgot Password?
            </Link>
          </Form>
        </div>
      </section>
    </>
  );
}
